import { configureStore } from '@reduxjs/toolkit';
import createSagaMiddleware, { END } from 'redux-saga';
import rootSaga from '../redux/rootSaga';
import { rootReducer } from '../redux/rootReducer';

export const sagaMiddleware = createSagaMiddleware({
  onError: (error) => {
    console.log(error); // eslint-disable-line no-console
    throw error;
  },
});

export const setupStore = (preloadedState) => {
  let store = configureStore({
    reducer: rootReducer,
    middleware: (getDefaultMiddleware) =>
      getDefaultMiddleware({
        serializableCheck: false,
        thunk: false,
      }).concat(sagaMiddleware),
    preloadedState,
  });
  store.close = () => store.dispatch(END);
  sagaMiddleware.run(rootSaga);
  return store;
};
